export function redondearDecimales(numero, decimales) {
    const numeroRegexp = new RegExp("\\d\\.(\\d){" + decimales + ",}");
    if (numeroRegexp.test(numero)) {
      return numero.toFixed(decimales); // Devuelve el número como cadena con dos decimales
    } else {
      return Number(numero.toFixed(decimales)) === 0 ? "0.00" : numero.toFixed(decimales);
    }
  }